module.exports = __webpack_public_path__ + "images/emoji/dizzy_face.a07b0b80be69bcbcee6e.png";